import {
  buildProps,
  definePropType,
  isObject,
  isString,
} from '@zoryn/utils'

import type { ExtractPublicPropTypes } from 'vue'
import type { Dayjs } from 'dayjs'

export interface SelectControllerProps {
  date: Dayjs
  formatter?: (value: number, type: 'year' | 'month') => string | number
}

/**
 *  @deprecated Removed after 3.0.0, Use `SelectControllerProps` instead.
 */
export const selectControllerProps = buildProps({
  date: {
    type: definePropType<Dayjs>(Object),
    required: true,
  },
  formatter: {
    type: definePropType<
      (value: number, type: 'year' | 'month') => string | number
    >(Function),
  },
} as const)

/**
 *  @deprecated Removed after 3.0.0, Use `SelectControllerProps` instead.
 */
export type SelectControllerPropsPublic = ExtractPublicPropTypes<
  typeof selectControllerProps
>

export const selectControllerEmits = {
  'date-change': (date: Dayjs | 'today') => isObject(date) || isString(date),
}
export type SelectControllerEmits = typeof selectControllerEmits
